const initialState = {};

const businesProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_BUSINESS_PROFILE":
      return action.payload;
    case "CLEAR_BUSINESS_PROFILE":
        return null;
    default:
      return state;
  }
};

export default businesProfileReducer;
